import React, {useEffect, useMemo, useState} from "react";
import {useSubheader} from "../../../../_metronic/layout";
import {ProductEditForm} from "./ProductEditForm";
import {useProductsUIContext} from "../ProductsUIContext";
import {getProduct} from "../crud/productCrud";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
    ModalProgressBar
} from "../../../../_metronic/_partials/controls";
import {Tab, Tabs} from "react-bootstrap";
import {shallowEqual, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import ProductPhotos from "./photos";


export default function ProductEdit({id}) {

    // Subheader
    const suhbeader = useSubheader();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [title, setTitle] = useState("");
    const productContext = useProductsUIContext();
    const productUIProps = useMemo(() => {
        return {
            product: productContext.product,
            setProduct: productContext.setProduct,
            setError: productContext.setError,
            setOpenError: productContext.setOpenError,
        };
    }, [productContext]);

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id !== 'new' ? "" : "محصول جدید";
        if (id !== 'new') {
            getProduct(id)
                .then((response) => {
                    productUIProps.setProduct(response.data.data);
                    setIsLoading(false);
                })
        } else {
            setIsLoading(false);
        }
        setTitle(_title);
        suhbeader.setTitle(_title);
    }, [id]);


    const backToProductsList = () => {
        history.push('/customer/products')
    };

    return (
        <>
            {!isLoading &&
            <Card>
                {actionsLoading && <ModalProgressBar/>}
                <CardHeader title={title}>
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            onClick={backToProductsList}
                            className="btn btn-light ml-2"
                        >
                            بازگشت
                            <i className="fa fa-arrow-left ml-2"/>
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Tabs defaultActiveKey="basic" className="nav nav-tabs nav-tabs-line " role="tablist">
                        <Tab eventKey="basic" title="اطلاعات">
                            <div className="mt-5">
                                <ProductEditForm
                                    product={productUIProps.product}
                                />
                            </div>
                        </Tab>

                        <Tab eventKey="photos" title="تصاویر">
                            <div className="mt-5">
                                <ProductPhotos/>
                            </div>
                        </Tab>

                    </Tabs>
                </CardBody>
            </Card>
            }
        </>

    );
}
